// import React, { useState, useEffect, useRef } from "react";
// import Header from "./Header.js";
// import Footer from "./Footer.js";
// import Select from "react-select";
// import { TailSpin } from "react-loader-spinner";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./Style.css";
// import AddDiscountCoupon from "../../Components/Admin_components/add_discount_coupons.js";
// import Update_gift_card from "../../Components/Admin_components/update_gift_card.js";
// import DeleteDiscountCoupon from "../../Components/Admin_components/delete_discount_coupons.js";
// import NewsComments from "../../Components/Admin_components/newsComment.js";
// import NewsSave from "../../Components/Admin_components/newsSave.js";
// import "../../Api/apiUrls";
// import { API_URL, getDiscountCoupons, updateDiscountCoupons } from "../../Api/apiUrls";
// import Toggle from "react-toggle";

// function DiscountCoupons() {
//   const [modalAdd_newsIsOpen, setAdd_newsModalIsOpen] = useState("");
//   const [modalUpdateDiscountCouponIsOpen, setUpdateDiscountCouponModalIsOpen] = useState(false);
//   const [modalDeleteDiscountCouponIsOpen, setDeleteDiscountCouponIsOpen] = useState(false);
//   const [modalNewsCommentsIsOpen, setNewsCommentsIsOpen] = useState(false);
//   const [modalNewsSaveIsOpen, setNewsSaveIsOpen] = useState(false);
//   const [selectedName, setSelectedName] = useState(null);
//   const [selectednewsImage, setSelectedNewsImage] = useState(null);
//   const [selectedEmail, setSelectedEmail] = useState(null);
//   const [selectedRemark, setSelectedRemark] = useState(null);
//   const [selectedSoldAt, setSelectedSoldAt] = useState(null);
//   const [selectedMobileNumber, setSelectedMobileNumber] = useState(null);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [selectedAuthor, setSelectedAuthor] = useState(null);
//   const [toggleStates, setToggleStates] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedNewsKeyword, setSelectedNewsKeyword] = useState(null);
//   const [discountCoupon, setDiscountCoupon] = useState([]);
//   const [selectedDiscountCouponId, setSelectedDiscountCouponId] = useState(null);
//   const [status, setStatus] = useState("All");
//   const [id, setId] = useState("");
//   const [statusDetails, setStatusDetails] = useState(null);
//   const [statusSingle, setStatusSingle] = useState([]);

//   const [isLoading, setIsLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [filteredItems, setFilteredItems] = useState(null);
//   const [newsSelectedAuthor, setNewSelectedAuthor] = useState(null);
//   const [pass, setPass] = useState([]);
//   const drop = [
//     { value: "All", label: "All" },
//     { value: "Active", label: "Active" },
//     { value: "Inactive", label: "Inactive" },
//   ];

//   const toggleSwitch = async (discountCouponId) => {
//     try {
//       const newToggleState = toggleStates[discountCouponId] === 1 ? 0 : 1;
//       const newStatus = newToggleState === 1 ? "Active" : "Inactive";
  
//       const response = await fetch(updateDiscountCoupons, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           status: newStatus,
//           discount_coupon_id: discountCouponId,
//         }),
//       });
  
//       if (!response.ok) {
//         throw new Error("Failed to update toggle state.");
//       }
  
//       const data = await response.json();
  
//       if (data.success) {
//         // Update the toggle state
//         setToggleStates((prevState) => ({
//           ...prevState,
//           [discountCouponId]: newToggleState,
//         }));
  
//         // Update the status in the pass state
//         setPass((prevPass) =>
//           prevPass.map((item) =>
//             item.id === discountCouponId ? { ...item, status: newStatus } : item
//           )
//         );
  
//         console.log("Toggle and status updated successfully:", data);
//       } else {
//         alert("Failed to update the toggle state. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating toggle state:", error);
//       alert("Failed to update the toggle state. Please try again.");
//     }
//   };

//   const handleStatusChange = (selectedOption) => {
//     setSelectedStatus(selectedOption.value);
//   };

//   const [searchQuery, setSearchQuery] = useState("");

//   const handleSearchInputChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const filteredBlogs = Array.isArray(discountCoupon)
//   ? discountCoupon.filter((discountCoupon) => {
//       const isStatus =
//         !selectedStatus ||
//         selectedStatus === "All" ||
//         discountCoupon.status === selectedStatus;
//       const values = Object.values(discountCoupon).map((value) =>
//         typeof value === "string" ? value.toLowerCase() : ""
//       );
//       const isSearchMatch = values.some((value) =>
//         value.includes(searchQuery.toLowerCase())
//       );
//       return isStatus && isSearchMatch;
//     })
//   : [];



//   const openAdd_news = () => {
//     closeAdd_news();
//     setAdd_newsModalIsOpen(true);
//   };

//   const closeAdd_news = () => {
//     setAdd_newsModalIsOpen(false);
//   };
//   const openUpdateDiscountCoupon = (
//     giftCardId,
//     name,
//     email,
//     remark,
//     sold_at,
//     mobileNumber,
//     address
//     // status
//   ) => {
//     setSelectedDiscountCouponId(giftCardId);
//     setSelectedName(name);
//     setSelectedEmail(email);
//     setSelectedRemark(remark);
//     setSelectedSoldAt(sold_at);
//     setSelectedMobileNumber(mobileNumber);
//     setSelectedAddress(address);
//     // setSelectedStatus(status);

//     closeUpdateDiscountCoupon();
//     setUpdateDiscountCouponModalIsOpen(true);
//   };

//   const closeUpdateDiscountCoupon = () => {
//     setUpdateDiscountCouponModalIsOpen(false);
//   };
//   const openDeleteDiscountCoupon = (giftCardId) => {
//     console.log('giftCardId')
//     console.log(giftCardId)
//     closeDeleteDiscountCoupon();
//     setSelectedDiscountCouponId(giftCardId);
//     setDeleteDiscountCouponIsOpen(true);
//   };

//   const closeDeleteDiscountCoupon = () => {
//     setDeleteDiscountCouponIsOpen(null);
//   };
//   const openNewsComments = (id) => {
//     closeNewsComments();
//     setId(id);
//     setNewsCommentsIsOpen(true);
//   };

//   const closeNewsComments = () => {
//     setNewsCommentsIsOpen(null);
//   };

//   const openNewsSave = (id) => {
//     closeNewsSave();
//     setId(id);
//     setNewsSaveIsOpen(true);
//   };

//   const closeNewsSave = () => {
//     setNewsSaveIsOpen(null);
//   };

//   useEffect(() => {
//     fetch(getDiscountCoupons)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         const discountCoupon = data.data.DiscountCoupon;
//         setDiscountCoupon(discountCoupon);
//         const initialToggleStates = discountCoupon.reduce((acc, item) => {
//         acc[item.id] = item.status === "Active" ? 1 : 0;
//         return acc;
//         }, {});
//         setToggleStates(initialToggleStates);
//       })
//       .catch((error) => console.error("Error fetching data:", error))
//       .finally(() => {
//         setIsLoading(false);
//       });
//   }, []);

//   const formatCreatedAt = (createdAt) => {
//     if (!createdAt) {
//       return "--";
//     }
  
//     const createdAtDate = new Date(createdAt);
  
//     // Check if the date is valid
//     if (isNaN(createdAtDate)) {
//       return "--";
//     }
  
//     // Format the date part
//     const datePart = createdAtDate.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
  
//     // Format the time part
//     const timePart = createdAtDate.toLocaleTimeString("en-GB", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
  
//     return `${datePart} ${timePart}`;
//   };
  

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };
  
//   return (
//     <div>
//       <Header></Header>

//       {modalAdd_newsIsOpen && <AddDiscountCoupon onClose={closeAdd_news} />}
//       {/* {modalUpdateDiscountCouponIsOpen && <UpdateDiscountCoupon onClose={closeUpdateDiscountCoupon} />} */}
//       {modalNewsCommentsIsOpen && (
//         <NewsComments onClose={closeNewsComments} id={id} />
//       )}
//       {modalNewsSaveIsOpen && <NewsSave onClose={closeNewsSave} id={id} />}

//       <main id="main" class="main">
//         <div class="pagetitle">
//           <h1>DiscountCoupons</h1>
//         </div>
//         <section class="section">
//           <div class="card p-2">
//             <div class="parent col-md-12 row mt-2">
//               <div class="col-md-6">
//                 <div class="child">
//                   <input
//                     onChange={handleSearchChange}
//                     value={searchQuery}
//                     id="myInput"
//                     type="text"
//                     style={{
//                       borderRadius: "5px",
//                       height: "35px",
//                       padding: "10px",
//                       border: "1px solid lightgrey ",
//                     }}
//                     placeholder="Search..."
//                   />
//                 </div>
//                 <div className="child ml-2">
//                   <Select
//                     options={drop}
//                     placeholder="Select Status"
//                     onChange={handleStatusChange}
//                   ></Select>
//                 </div>
//               </div>

//               <div class="col-md-6" style={{ textAlign: "right" }}>
//                 <div class="child">
//                   <a>
//                     {" "}
//                     <button
//                       id="btnNewUser"
//                       type="button"
//                       data-toggle="modal"
//                       data-target="#modalAdd"
//                       class=" btn-round"
//                       onClick={openAdd_news}
//                     >
//                       <i class="bi bi-person-add"></i> Add Discount Coupon
//                     </button>
//                   </a>
//                 </div>
//               </div>
//             </div>

//             <div
//               style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
//             >
//               {/* <TailSpin color="black" width={50} /> */}
//             </div>
//             <div class="table-responsive">
//               {isLoading === true ? (
//                 <div
//                   style={{
//                     marginTop: "50px",
//                     display: "flex",
//                     marginLeft: "50%",
//                   }}
//                 >
//                   <TailSpin color="black" width={50} />
//                 </div>
//               ) : discountCoupon && discountCoupon.length > 0 ? (
//                 <table class="table table-striped " style={{ padding: "0rem" }}>
//                   <thead>
//                     <tr>
//                       <th scope="col">Sr.no</th>
//                       <th scope="col">Status</th>
//                       <th scope="col">Passes</th>
//                       <th scope="col">Coupon Code</th>
//                       <th scope="col">Discount Percent (%)</th>
//                       <th scope="col">Max Discount Amount</th>
//                       <th scope="col">Minimum Order Amount</th>
//                       <th scope="col">Usage Limit</th>
//                       <th scope="col">Usage Count</th>
//                       <th scope="col">Applicable For</th>
//                       <th scope="col">Created_On</th>
//                       <th scope="col">Expiring_On</th>
//                       {/* <th scope="col">Action</th> */}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredBlogs.map((discountCoupon, index) => (
//                       <tr key={discountCoupon.id}>
//                         <th scope="row">{index + 1}</th>
                        
//                         <td>
//                             <Toggle
//                                 checked={toggleStates[discountCoupon.id] === 1}
//                                 onChange={() => toggleSwitch(discountCoupon.id)}
//                             />
//                         </td>
//                         <td>
//                         {discountCoupon.passes?.length > 0
//                             ? discountCoupon.passes.map((pass, index) => (
//                                 <div key={index}>
//                                 {pass.title}({pass.duration_type}),
//                                 <br />
//                                 </div>
//                             ))
//                             : "---"}
//                         </td>

//                         <td>{discountCoupon.code || "---"}</td>
//                         <td>
//                           {discountCoupon.discount_value || "---"}
//                         </td>
//                         <td>
//                           {discountCoupon.max_discount_amount || "---"}
//                         </td>
//                         <td>{discountCoupon.min_order_amount || "0"}</td>
//                         <td>{discountCoupon.usage_limit || "0"}</td>
//                         <td>{discountCoupon.usage_count || "0"}</td>
//                         <td>{discountCoupon.applies_to || "0"}</td>
//                         <td>{formatCreatedAt(discountCoupon.created_at)}</td>
//                         <td>{formatCreatedAt(discountCoupon.expiry_date)}</td>
                        
//                         {/* <td>
//                           <div className="social-links mt-2">
//                             <a
//                               style={{ cursor: "pointer" }}
//                               onClick={() =>
//                                 openUpdateDiscountCoupon(
//                                   discountCoupon.id,
//                                   discountCoupon.name,
//                                   discountCoupon.email,
//                                   discountCoupon.remark,
//                                   discountCoupon.sold_at,
//                                   discountCoupon.mobileNumber,
//                                   discountCoupon.address,
//                                 )
//                               }
//                             >
//                               <i class="bi bi-pencil"></i>
//                             </a>
//                             &nbsp;&nbsp;
//                             <a
//                               style={{ cursor: "pointer" }}
//                               onClick={() =>  openDeleteDiscountCoupon(discountCoupon.id)}
//                             >
//                               <i class="bi bi-trash3"></i>
//                             </a>
//                             &nbsp;
//                           </div>
//                         </td> */}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <h3 style={{ textAlign: "center" }}> No data available </h3>
//               )}

//               {modalUpdateDiscountCouponIsOpen && (
//                 <Update_gift_card
//                   giftCardId={selectedDiscountCouponId}
//                   name={selectedName}
//                   email={selectedEmail}
//                   remark={selectedRemark}
//                   sold_at={selectedSoldAt}
//                   mobileNumber={selectedMobileNumber}
//                   address={selectedAddress}
//                 //   status={selectednewsSummary}
//                   onClose={closeUpdateDiscountCoupon}
//                 />
//               )}

//               {modalDeleteDiscountCouponIsOpen && (
//                 <DeleteDiscountCoupon
//                   giftCardId={selectedDiscountCouponId}
//                   onClose={closeDeleteDiscountCoupon}
//                 />
//               )}
//             </div>
//           </div>
//           <div>
//             {" "}
//             <p
//               style={{
//                 backgroundColor: "#000",
//                 color: "white",
//                 padding: "10px",
//               }}
//             >
//               {filteredBlogs.length || 0} Total
//             </p>
//           </div>
//         </section>
//       </main>
//       <Footer></Footer>
//     </div>
//   );
// }

// export default DiscountCoupons;


// import React, { useState, useEffect } from "react";
// import Header from "./Header.js";
// import Footer from "./Footer.js";
// import Select from "react-select";
// import { TailSpin } from "react-loader-spinner";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./Style.css";
// import AddDiscountCoupon from "../../Components/Admin_components/add_discount_coupons.js";
// import Update_gift_card from "../../Components/Admin_components/update_gift_card.js";
// import DeleteDiscountCoupon from "../../Components/Admin_components/delete_discount_coupons.js";
// import Toggle from "react-toggle";
// import "react-toggle/style.css";
// import { API_URL, getDiscountCoupons, updateDiscountCoupons } from "../../Api/apiUrls";

// function DiscountCoupons() {
//   const [modalAddIsOpen, setAddModalIsOpen] = useState(false);
//   const [modalUpdateDiscountCouponIsOpen, setUpdateDiscountCouponModalIsOpen] = useState(false);
//   const [modalDeleteDiscountCouponIsOpen, setDeleteDiscountCouponIsOpen] = useState(false);
//   const [selectedDiscountCoupon, setSelectedDiscountCoupon] = useState(null);
//   const [discountCoupons, setDiscountCoupons] = useState([]);
//   const [toggleStates, setToggleStates] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState("All");
//   const [isLoading, setIsLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
  
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   const statusOptions = [
//     { value: "All", label: "All" },
//     { value: "Active", label: "Active" },
//     { value: "Inactive", label: "Inactive" },
//   ];

//   const itemsPerPageOptions = [
//     { value: 5, label: "5 per page" },
//     { value: 10, label: "10 per page" },
//     { value: 20, label: "20 per page" },
//     { value: 50, label: "50 per page" },
//   ];

//   const toggleSwitch = async (discountCouponId) => {
//     try {
//       const coupon = discountCoupons.find(item => item.id === discountCouponId);
//       const newStatus = coupon.status === "Active" ? "Inactive" : "Active";
      
//       const response = await fetch(updateDiscountCoupons, {
//         method: "PUT",
//         headers: { 
//           "Content-Type": "application/json",
//           "X-CSRFToken": getCookie('csrftoken')
//         },
//         body: JSON.stringify({
//           status: newStatus,
//           discount_coupon_id: discountCouponId,
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to update status.");
//       }

//       const data = await response.json();

//       if (data.success) {
//         setDiscountCoupons(prev => 
//           prev.map(item => 
//             item.id === discountCouponId 
//               ? { ...item, status: newStatus } 
//               : item
//           )
//         );
        
//         setToggleStates(prev => ({
//           ...prev,
//           [discountCouponId]: newStatus === "Active"
//         }));
//       } else {
//         alert("Failed to update the status. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       alert("Failed to update the status. Please try again.");
//     }
//   };

//   const handleStatusChange = (selectedOption) => {
//     setSelectedStatus(selectedOption.value);
//     setCurrentPage(1); // Reset to first page when filter changes
//   };

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//     setCurrentPage(1); // Reset to first page when search changes
//   };

//   const handleItemsPerPageChange = (selectedOption) => {
//     setItemsPerPage(selectedOption.value);
//     setCurrentPage(1); // Reset to first page when items per page changes
//   };

//   const openAddModal = () => {
//     setAddModalIsOpen(true);
//   };

//   const closeAddModal = () => {
//     setAddModalIsOpen(false);
//   };

//   const openUpdateDiscountCoupon = (coupon) => {
//     setSelectedDiscountCoupon(coupon);
//     setUpdateDiscountCouponModalIsOpen(true);
//   };

//   const closeUpdateDiscountCoupon = () => {
//     setUpdateDiscountCouponModalIsOpen(false);
//     setSelectedDiscountCoupon(null);
//   };

//   const openDeleteDiscountCoupon = (couponId) => {
//     setSelectedDiscountCoupon(couponId);
//     setDeleteDiscountCouponIsOpen(true);
//   };

//   const closeDeleteDiscountCoupon = () => {
//     setDeleteDiscountCouponIsOpen(false);
//     setSelectedDiscountCoupon(null);
//   };

//   useEffect(() => {
//     const fetchDiscountCoupons = async () => {
//       try {
//         // Add pagination parameters to the API call
//         const url = `${getDiscountCoupons}?page=${currentPage}&page_size=${itemsPerPage}`;
//         const response = await fetch(url);
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         const data = await response.json();
        
//         if (data.success) {
//           const coupons = data.data.DiscountCoupon;
//           const pagination = data.data.pagination;
          
//           setDiscountCoupons(coupons);
//           setTotalItems(pagination.total_items);
//           setTotalPages(pagination.total_pages);
          
//           const initialToggleStates = {};
//           coupons.forEach(item => {
//             initialToggleStates[item.id] = item.status === "Active";
//           });
//           setToggleStates(initialToggleStates);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchDiscountCoupons();
//   }, [currentPage, itemsPerPage]); // Re-fetch when page or items per page changes

//   const formatCreatedAt = (dateString) => {
//     if (!dateString) return "--";
    
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date)) return "--";
      
//       return date.toLocaleString("en-GB", {
//         day: "numeric",
//         month: "short",
//         year: "numeric",
//         hour: "numeric",
//         minute: "numeric",
//         hour12: true
//       });
//     } catch (error) {
//       return "--";
//     }
//   };

//   // Filter coupons based on status and search query (client-side filtering)
//   const filteredCoupons = discountCoupons.filter(coupon => {
//     const statusMatch = selectedStatus === "All" || coupon.status === selectedStatus;
//     const searchMatch = Object.values(coupon).some(value => 
//       value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     return statusMatch && searchMatch;
//   });

//   // Calculate pagination details
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
//   const displayedItemsCount = filteredCoupons.length;

//   // Generate page numbers for pagination controls
//   const getPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }
    
//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(i);
//     }
    
//     return pages;
//   };

//   // Function to get CSRF token
//   const getCookie = (name) => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(';').shift();
//     return null;
//   };

//   return (
//     <div>
//       <Header />
      
//       {modalAddIsOpen && <AddDiscountCoupon onClose={closeAddModal} />}
//       {modalUpdateDiscountCouponIsOpen && selectedDiscountCoupon && (
//         <Update_gift_card 
//           coupon={selectedDiscountCoupon} 
//           onClose={closeUpdateDiscountCoupon} 
//         />
//       )}
//       {modalDeleteDiscountCouponIsOpen && selectedDiscountCoupon && (
//         <DeleteDiscountCoupon 
//           couponId={selectedDiscountCoupon} 
//           onClose={closeDeleteDiscountCoupon} 
//         />
//       )}

//       <main id="main" className="main">
//         <div className="pagetitle">
//           <h1>Discount Coupons</h1>
//         </div>
        
//         <section className="section">
//           <div className="card p-2">
//             <div className="parent col-md-12 row mt-2">
//               <div className="col-md-6 d-flex align-items-center">
//                 <input
//                   onChange={handleSearchChange}
//                   value={searchQuery}
//                   type="text"
//                   className="form-control me-2"
//                   style={{ width: '200px' }}
//                   placeholder="Search..."
//                 />
//                 <Select
//                   options={statusOptions}
//                   placeholder="Select Status"
//                   onChange={handleStatusChange}
//                   className="basic-select me-2"
//                   classNamePrefix="select"
//                   styles={{
//                     control: (base) => ({
//                       ...base,
//                       minHeight: '35px',
//                       height: '35px',
//                       width: '150px'
//                     }),
//                   }}
//                 />
//                 <Select
//                   options={itemsPerPageOptions}
//                   value={itemsPerPageOptions.find(opt => opt.value === itemsPerPage)}
//                   onChange={handleItemsPerPageChange}
//                   className="basic-select"
//                   classNamePrefix="select"
//                   styles={{
//                     control: (base) => ({
//                       ...base,
//                       minHeight: '35px',
//                       height: '35px',
//                       width: '130px'
//                     }),
//                   }}
//                 />
//               </div>

//               <div className="col-md-6 text-end">
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-round"
//                   onClick={openAddModal}
//                 >
//                   <i className="bi bi-person-add"></i> Add Discount Coupon
//                 </button>
//               </div>
//             </div>

//             <div className="table-responsive mt-3">
//               {isLoading ? (
//                 <div className="text-center py-4">
//                   <TailSpin color="#000" height={50} width={50} />
//                 </div>
//               ) : filteredCoupons.length > 0 ? (
//                 <>
//                   <table className="table table-striped">
//                     <thead>
//                       <tr>
//                         <th scope="col">Sr.no</th>
//                         <th scope="col">Status</th>
//                         <th scope="col">Passes</th>
//                         <th scope="col">Coupon Code</th>
//                         <th scope="col">Discount Percent (%)</th>
//                         <th scope="col">Max Discount Amount</th>
//                         <th scope="col">Minimum Order Amount</th>
//                         <th scope="col">Usage Limit</th>
//                         <th scope="col">Usage Count</th>
//                         <th scope="col">Applicable For</th>
//                         <th scope="col">Created On</th>
//                         <th scope="col">Expiring On</th>
//                         {/* <th scope="col">Actions</th> */}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredCoupons.map((coupon, index) => (
//                         <tr key={coupon.id}>
//                           <th scope="row">{startIndex + index + 1}</th>
//                           <td>
//                             <Toggle
//                               checked={toggleStates[coupon.id] || false}
//                               onChange={() => toggleSwitch(coupon.id)}
//                               icons={false}
//                             />
//                           </td>
//                           <td>
//                             {coupon.passes?.length > 0
//                               ? coupon.passes.map((pass, idx) => (
//                                   <div key={idx}>
//                                     {pass.title} ({pass.duration_type})
//                                     {idx < coupon.passes.length - 1 && <br />}
//                                   </div>
//                                 ))
//                               : "---"}
//                           </td>
//                           <td>{coupon.code || "---"}</td>
//                           <td>{coupon.discount_value || "---"}</td>
//                           <td>{coupon.max_discount_amount || "---"}</td>
//                           <td>{coupon.min_order_amount || "0"}</td>
//                           <td>{coupon.usage_limit || "0"}</td>
//                           <td>{coupon.usage_count || "0"}</td>
//                           <td>{coupon.applies_to || "All"}</td>
//                           <td>{formatCreatedAt(coupon.created_at)}</td>
//                           <td>{formatCreatedAt(coupon.expiry_date)}</td>
//                           {/* <td>
//                             <div className="d-flex">
//                               <button
//                                 className="btn btn-sm btn-outline-primary me-2"
//                                 onClick={() => openUpdateDiscountCoupon(coupon)}
//                               >
//                                 <i className="bi bi-pencil"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-outline-danger"
//                                 onClick={() => openDeleteDiscountCoupon(coupon.id)}
//                               >
//                                 <i className="bi bi-trash3"></i>
//                               </button>
//                             </div>
//                           </td> */}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
                  
//                   {/* Pagination Controls */}
//                   <div className="d-flex justify-content-between align-items-center mt-3">
//                     <div>
//                       Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} entries
//                     </div>
//                     <nav>
//                       <ul className="pagination">
//                         <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                           <button 
//                             className="page-link" 
//                             onClick={() => setCurrentPage(1)}
//                             disabled={currentPage === 1}
//                           >
//                             First
//                           </button>
//                         </li>
//                         <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                           <button 
//                             className="page-link" 
//                             onClick={() => setCurrentPage(currentPage - 1)}
//                             disabled={currentPage === 1}
//                           >
//                             Previous
//                           </button>
//                         </li>
                        
//                         {getPageNumbers().map(page => (
//                           <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
//                             <button 
//                               className="page-link" 
//                               onClick={() => setCurrentPage(page)}
//                             >
//                               {page}
//                             </button>
//                           </li>
//                         ))}
                        
//                         <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                           <button 
//                             className="page-link" 
//                             onClick={() => setCurrentPage(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                           >
//                             Next
//                           </button>
//                         </li>
//                         <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                           <button 
//                             className="page-link" 
//                             onClick={() => setCurrentPage(totalPages)}
//                             disabled={currentPage === totalPages}
//                           >
//                             Last
//                           </button>
//                         </li>
//                       </ul>
//                     </nav>
//                   </div>
//                 </>
//               ) : (
//                 <div className="text-center py-4">
//                   <h3>No discount coupons available</h3>
//                 </div>
//               )}
//             </div>
//           </div>
//         </section>
//       </main>
      
//       <Footer />
//     </div>
//   );
// }

// export default DiscountCoupons;

import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import { TailSpin } from "react-loader-spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import AddDiscountCoupon from "../../Components/Admin_components/add_discount_coupons.js";
import Update_gift_card from "../../Components/Admin_components/update_gift_card.js";
import DeleteDiscountCoupon from "../../Components/Admin_components/delete_discount_coupons.js";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { API_URL, getDiscountCoupons, updateDiscountCoupons } from "../../Api/apiUrls";

function DiscountCoupons() {
  const [modalAddIsOpen, setAddModalIsOpen] = useState(false);
  const [modalUpdateDiscountCouponIsOpen, setUpdateDiscountCouponModalIsOpen] = useState(false);
  const [modalDeleteDiscountCouponIsOpen, setDeleteDiscountCouponIsOpen] = useState(false);
  const [selectedDiscountCoupon, setSelectedDiscountCoupon] = useState(null);
  const [discountCoupons, setDiscountCoupons] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const statusOptions = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const itemsPerPageOptions = [
    { value: 5, label: "5 per page" },
    { value: 10, label: "10 per page" },
    { value: 20, label: "20 per page" },
    { value: 50, label: "50 per page" },
  ];

  const toggleSwitch = async (discountCouponId) => {
    try {
      const coupon = discountCoupons.find(item => item.id === discountCouponId);
      const newStatus = coupon.status === "Active" ? "Inactive" : "Active";
      
      const response = await fetch(updateDiscountCoupons, {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie('csrftoken')
        },
        body: JSON.stringify({
          status: newStatus,
          discount_coupon_id: discountCouponId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update status.");
      }

      const data = await response.json();

      if (data.success) {
        // After updating status, refetch the data to stay in sync with filters
        fetchDiscountCoupons();
      } else {
        alert("Failed to update the status. Please try again.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update the status. Please try again.");
    }
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Add debounced search to avoid too many API calls
  useEffect(() => {
    const timerId = setTimeout(() => {
      setCurrentPage(1); // Reset to first page when search changes
      fetchDiscountCoupons();
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(timerId);
    };
  }, [searchQuery]);

  const handleItemsPerPageChange = (selectedOption) => {
    setItemsPerPage(selectedOption.value);
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  const openAddModal = () => {
    setAddModalIsOpen(true);
  };

  const closeAddModal = () => {
    setAddModalIsOpen(false);
    // Refresh the list after adding a new coupon
    fetchDiscountCoupons();
  };

  const openUpdateDiscountCoupon = (coupon) => {
    setSelectedDiscountCoupon(coupon);
    setUpdateDiscountCouponModalIsOpen(true);
  };

  const closeUpdateDiscountCoupon = () => {
    setUpdateDiscountCouponModalIsOpen(false);
    setSelectedDiscountCoupon(null);
    // Refresh the list after updating a coupon
    fetchDiscountCoupons();
  };

  const openDeleteDiscountCoupon = (couponId) => {
    setSelectedDiscountCoupon(couponId);
    setDeleteDiscountCouponIsOpen(true);
  };

  const closeDeleteDiscountCoupon = () => {
    setDeleteDiscountCouponIsOpen(false);
    setSelectedDiscountCoupon(null);
    // Refresh the list after deleting a coupon
    fetchDiscountCoupons();
  };

  const fetchDiscountCoupons = async () => {
    try {
      setIsLoading(true);
      
      // Build query parameters
      const params = new URLSearchParams({
        page: currentPage,
        page_size: itemsPerPage,
      });
      
      // Add status filter if not "All"
      if (selectedStatus !== "All") {
        params.append('status', selectedStatus);
      }
      
      // Add search query if not empty
      if (searchQuery) {
        params.append('search', searchQuery);
      }
      
      const url = `${getDiscountCoupons}?${params.toString()}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      
      const data = await response.json();
      
      if (data.success) {
        const coupons = data.data.DiscountCoupon;
        const pagination = data.data.pagination;
        
        setDiscountCoupons(coupons);
        setTotalItems(pagination.total_items);
        setTotalPages(pagination.total_pages);
        
        const initialToggleStates = {};
        coupons.forEach(item => {
          initialToggleStates[item.id] = item.status === "Active";
        });
        setToggleStates(initialToggleStates);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDiscountCoupons();
  }, [currentPage, itemsPerPage, selectedStatus]); // Re-fetch when page, items per page, or status changes

  const formatCreatedAt = (dateString) => {
    if (!dateString) return "--";
    
    try {
      const date = new Date(dateString);
      if (isNaN(date)) return "--";
      
      return date.toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      });
    } catch (error) {
      return "--";
    }
  };

  // Calculate pagination details
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Generate page numbers for pagination controls
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  // Function to get CSRF token
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  return (
    <div>
      <Header />
      
      {modalAddIsOpen && <AddDiscountCoupon onClose={closeAddModal} />}
      {modalUpdateDiscountCouponIsOpen && selectedDiscountCoupon && (
        <Update_gift_card 
          coupon={selectedDiscountCoupon} 
          onClose={closeUpdateDiscountCoupon} 
        />
      )}
      {modalDeleteDiscountCouponIsOpen && selectedDiscountCoupon && (
        <DeleteDiscountCoupon 
          couponId={selectedDiscountCoupon} 
          onClose={closeDeleteDiscountCoupon} 
        />
      )}

      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Discount Coupons</h1>
        </div>
        
        <section className="section">
          <div className="card p-2">
            <div className="parent col-md-12 row mt-2">
              <div className="col-md-6 d-flex align-items-center">
                <input
                  onChange={handleSearchChange}
                  value={searchQuery}
                  type="text"
                  className="form-control me-2"
                  style={{ width: '200px' }}
                  placeholder="Search..."
                />
                <Select
                  options={statusOptions}
                  value={statusOptions.find(opt => opt.value === selectedStatus)}
                  placeholder="Select Status"
                  onChange={handleStatusChange}
                  className="basic-select me-2"
                  classNamePrefix="select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '35px',
                      height: '35px',
                      width: '150px'
                    }),
                  }}
                />
                <Select
                  options={itemsPerPageOptions}
                  value={itemsPerPageOptions.find(opt => opt.value === itemsPerPage)}
                  onChange={handleItemsPerPageChange}
                  className="basic-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '35px',
                      height: '35px',
                      width: '130px'
                    }),
                  }}
                />
              </div>

              <div className="col-md-6 text-end">
                <button
                  type="button"
                  className="btn btn-primary btn-round"
                  onClick={openAddModal}
                >
                  <i className="bi bi-person-add"></i> Add Discount Coupon
                </button>
              </div>
            </div>

            <div className="table-responsive mt-3">
              {isLoading ? (
                <div className="text-center py-4">
                  <TailSpin color="#000" height={50} width={50} />
                </div>
              ) : discountCoupons.length > 0 ? (
                <>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Sr.no</th>
                        <th scope="col">Status</th>
                        <th scope="col">Passes</th>
                        <th scope="col">Coupon Code</th>
                        <th scope="col">Discount Percent (%)</th>
                        <th scope="col">Max Discount Amount</th>
                        <th scope="col">Minimum Order Amount</th>
                        <th scope="col">Usage Limit</th>
                        <th scope="col">Usage Count</th>
                        <th scope="col">Applicable For</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Expiring On</th>
                        {/* <th scope="col">Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {discountCoupons.map((coupon, index) => (
                        <tr key={coupon.id}>
                          <th scope="row">{startIndex + index + 1}</th>
                          <td>
                            <Toggle
                              checked={toggleStates[coupon.id] || false}
                              onChange={() => toggleSwitch(coupon.id)}
                              icons={false}
                            />
                          </td>
                          <td>
                            {coupon.passes?.length > 0
                              ? coupon.passes.map((pass, idx) => (
                                  <div key={idx}>
                                    {pass.title} ({pass.duration_type})
                                    {idx < coupon.passes.length - 1 && <br />}
                                  </div>
                                ))
                              : "---"}
                          </td>
                          <td>{coupon.code || "---"}</td>
                          <td>{coupon.discount_value || "---"}</td>
                          <td>{coupon.max_discount_amount || "---"}</td>
                          <td>{coupon.min_order_amount || "0"}</td>
                          <td>{coupon.usage_limit || "0"}</td>
                          <td>{coupon.usage_count || "0"}</td>
                          <td>{coupon.applies_to || "All"}</td>
                          <td>{formatCreatedAt(coupon.created_at)}</td>
                          <td>{formatCreatedAt(coupon.expiry_date)}</td>
                          {/* <td>
                            <div className="d-flex">
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => openUpdateDiscountCoupon(coupon)}
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => openDeleteDiscountCoupon(coupon.id)}
                              >
                                <i className="bi bi-trash3"></i>
                              </button>
                            </div>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  
                  {/* Pagination Controls */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} entries
                    </div>
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1}
                          >
                            First
                          </button>
                        </li>
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        
                        {getPageNumbers().map(page => (
                          <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <button 
                              className="page-link" 
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          </li>
                        ))}
                        
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </button>
                        </li>
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                          >
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </>
              ) : (
                <div className="text-center py-4">
                  <h3>No discount coupons found</h3>
                  {searchQuery || selectedStatus !== "All" ? (
                    <p>Try adjusting your search or filter criteria</p>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}

export default DiscountCoupons;
